import { useAttachmentPreviewController } from '#pplx/frontend/apps/ask/composer-ui/useAttachmentPreviewController.js';
import { useCallback } from 'react';
export function useComposerAttachmentPreview({ onPreview, }) {
    const { openAttachmentPreview, previewOverlay } = useAttachmentPreviewController();
    const onPreviewAttachment = useCallback((target) => {
        const presentation = openAttachmentPreview(target);
        onPreview?.(presentation);
    }, [onPreview, openAttachmentPreview]);
    return { onPreviewAttachment, previewOverlay };
}
//# sourceMappingURL=useComposerAttachmentPreview.js.map